import { observable, action, set, computed } from 'mobx';

export interface IEmailOptIn {
    communicationType: string;
    emailAddress: string;
    emailSubscribed: boolean;
    id: string;
}

export class EmailOptIn {
    @observable public communicationType: string;
    @observable public emailAddress: string;
    @observable public emailSubscribed: boolean = false;
    @observable public id: string;
    @observable public source: string;

    public static FROM_JSON(data: IEmailOptIn) {
        const emailOptInResponse = new EmailOptIn();
        set(emailOptInResponse, data);

        return emailOptInResponse;
    }

    @action
    public toggleEmailSubscribed = () => {
        this.emailSubscribed = !this.emailSubscribed;
    };

    @action
    public updateEmailSubscribed = (emailSubscribed: boolean) => {
        this.emailSubscribed = emailSubscribed;
    };

    @action
    public clearEmailSubscribed = () => {
        this.emailSubscribed = false;
    };

    @computed
    public get isEmailSubscribed() {
        return this.emailSubscribed;
    }
}
